// @flow
export default (theme: Object) => ({
    paper: {
        maxWidth: 540,
        maxHeight: 1000,
        padding: theme.spacing(4, 3),
        margin: [[0, 'auto', theme.spacing(3)]],
        color: theme.palette.common.black,

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(4, 2),
        },
    },
});
